export default "__VITE_ASSET__c6236427__"